module.exports = __webpack_public_path__ + "img/arrow.a1de1229.png";